const apiUrl = process.env.REACT_APP_API_URL;
export const PostProjectesIdGrupIdAlumneIdNp = async (
                                                        id_projecte: string,
                                                        id_grup: string,
                                                        is_alumne: string,
                                                        avaluacio: any,
                                                        sprint: string) => {
    try {
        const response = await fetch(`${apiUrl}:8061/projectes/${id_projecte}/grups/${id_grup}/alumnes/${is_alumne}/np`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({avaluacio : avaluacio, sprint: sprint})
        })
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
